exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app-link[data-v-2a67c53d] {\r\n  display: flex;\r\n  align-items: center;\n}\n.app-link.black[data-v-2a67c53d] {\r\n  filter: drop-shadow(0px 0px 5px #39c0ee);\n}\n@media (max-width: 767px) {\n.app-link.black[data-v-2a67c53d] {\r\n    box-shadow: none;\n}\n}\r\n", ""]);

// exports
